// extracted by mini-css-extract-plugin
export default {"footerBg":"na-z","footerTopLinks":"oa-z","footerFeedback":"pa-z","footerSocial":"qa-z","footerLegalLinks":"ra-z","footerIconCards":"sa-z","footerBotCopy":"ta-z"};